import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/home/runner/work/Planner/Planner/src/app/_loading/skeleton.tsx");
